import { NICmsContentComponent } from '../interfaces/icms-content-component.interfaces';
import { ICmsProviderBlockContent } from './provider/icms-provider-block-content';
import { ICmsProviderDefault } from './provider/icms-provider-default';

export function ICmsContent<T>(contentMeta: NICmsContentComponent.IContentMeta) {
    return function (target: NICmsContentComponent.IComponent, propertyKey: string | symbol) {
        switch (contentMeta.type) {
            case 'blockContent':
            case 'componentOrBlockContent':
                new ICmsProviderBlockContent<T>(contentMeta, target, propertyKey);
                break;
            default:
                new ICmsProviderDefault<T>(contentMeta, target, propertyKey);
                break;
        }
    };
}
